import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esKetamineOverview } from "@/pages/es/esConditionData4";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/ketamine-treatment-coral-springs-fl")(
  {
    head: () => buildEsConditionHead(esKetamineOverview),
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esKetamineOverview} />;
}
